import React, { createContext, useContext } from "react";
import type { AssistantApi } from "~/components/assistant/api/AssistantApi";

interface AssistantContextValue {
  api: AssistantApi;
  conversationId: string | null;
  contextId?: string;
  // TODO: Consider adding debugMode here to avoid prop drilling through multiple layers
}

const AssistantContext = createContext<AssistantContextValue | null>(null);

interface AssistantProviderProps {
  api: AssistantApi;
  conversationId: string | null;
  contextId?: string;
  children: React.ReactNode;
}

export function AssistantProvider({
  api,
  conversationId,
  contextId,
  children,
}: AssistantProviderProps) {
  return (
    <AssistantContext.Provider value={{ api, conversationId, contextId }}>
      {children}
    </AssistantContext.Provider>
  );
}

export function useAssistantContext() {
  const context = useContext(AssistantContext);
  if (!context) {
    throw new Error("useAssistantContext must be used within AssistantProvider");
  }
  return context;
}
